import { useDispatch } from 'react-redux';
import './css/app.css'
import './css/common.css'
import { useState, useEffect, useRef } from 'react';
import { change_Current_Location, changeHeaderTitle } from '../store';
import axios from 'axios';
import { MessageModal, LoadingModal } from './component/modal/modal';
import { SearchDateSplit } from './component/search/search';
import { useNavigate } from 'react-router-dom';
import { changeNum, datePickerCommonOpts, paintWeekendColors } from './common/function';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { X, Search, ChevronUp, ChevronDown, ChevronsUpDown, FileX } from 'lucide-react';
import Litepicker from 'litepicker';
import { SyncLoader } from "react-spinners";

dayjs.extend(utc);
dayjs.extend(timezone);

const safeNum = (v) => changeNum(Number(v) || 0);

const TX_TYPE_OPTIONS = {
    '전체': '', '입금': 'DEPOSIT', '출금': 'WITHDRAW', '취소차감': 'CANCEL_DEDUCT',
    '잠금': 'LOCK', '잠금해제': 'UNLOCK', '조정': 'ADJUST', '수수료': 'FEE', '이체': 'TRANSFER',
};
const TX_TYPE_KR = {
    'DEPOSIT': '입금', 'WITHDRAW': '출금', 'CANCEL_DEDUCT': '취소차감',
    'LOCK': '잠금', 'UNLOCK': '잠금해제', 'ADJUST': '조정', 'FEE': '수수료', 'TRANSFER': '이체',
};
const TX_STATUS_OPTIONS = { '전체': '', '대기': 'PENDING', '성공': 'SUCCESS', '실패': 'FAILED', '취소': 'CANCELED' };
const TX_DIRECTION_COLOR = { 'IN': '#059669', 'OUT': '#dc2626', 'NEUTRAL': '#6b7280' };
const TX_DIRECTION_KR = { 'IN': '입금', 'OUT': '출금', 'NEUTRAL': '-' };

const colFlex = (col) => {
    if (col.flex) return { flex: col.flex, minWidth: col.width, flexShrink: 1 };
    return { minWidth: col.width, width: col.width, flexShrink: 0 };
};

// ─── 컬럼 정의 ───
const MERCHANT_COLUMNS = [
    { key: "created_at", text: "일시", width: "130px", bodyAlign: "center" },
    { key: "mid", text: "MID", width: "70px", flex: 0.8, bodyAlign: "center", filterable: true, filterParam: "mid" },
    { key: "merchant_name", text: "가맹점명", width: "100px", flex: 1.2, bodyAlign: "left" },
    { key: "boss_name", text: "대표자명", width: "70px", flex: 0.8, bodyAlign: "center" },
    { key: "tx_type", text: "거래유형", width: "80px", bodyAlign: "center", selectable: true, filterParam: "txType", selectOptions: TX_TYPE_OPTIONS },
    { key: "tx_direction", text: "방향", width: "55px", bodyAlign: "center" },
    { key: "amount", text: "금액", width: "90px", flex: 1, bodyAlign: "right", sortable: true },
    { key: "balance_before", text: "잔액(전)", width: "90px", flex: 1, bodyAlign: "right", sortable: true },
    { key: "balance_after", text: "잔액(후)", width: "90px", flex: 1, bodyAlign: "right", sortable: true },
    { key: "status", text: "상태", width: "65px", bodyAlign: "center", selectable: true, filterParam: "status", selectOptions: TX_STATUS_OPTIONS },
    { key: "bank_nm", text: "은행", width: "70px", flex: 0.7, bodyAlign: "center" },
    { key: "accnt_no", text: "계좌번호", width: "100px", flex: 1, bodyAlign: "center" },
];

const AGENT_TX_TYPE_OPTIONS = { '전체': '', '입금': 'DEPOSIT', '출금': 'WITHDRAW' };
const AGENT_TX_TYPE_KR = { 'DEPOSIT': '입금', 'WITHDRAW': '출금' };

const AGENT_COLUMNS = [
    { key: "created_at", text: "일시", width: "130px", bodyAlign: "center" },
    { key: "agent_id", text: "에이전트ID", width: "80px", flex: 0.8, bodyAlign: "center", filterable: true, filterParam: "agentId" },
    { key: "agent_nm", text: "에이전트명", width: "100px", flex: 1.2, bodyAlign: "left" },
    { key: "tx_type", text: "거래유형", width: "70px", bodyAlign: "center", selectable: true, filterParam: "txType", selectOptions: AGENT_TX_TYPE_OPTIONS },
    { key: "amount", text: "금액", width: "90px", flex: 1, bodyAlign: "right", sortable: true },
    { key: "fee", text: "수수료", width: "70px", bodyAlign: "right" },
    { key: "final_amount", text: "최종금액", width: "90px", flex: 1, bodyAlign: "right", sortable: true },
    { key: "balance_after", text: "잔액(후)", width: "90px", flex: 1, bodyAlign: "right", sortable: true },
    { key: "status", text: "상태", width: "65px", bodyAlign: "center", selectable: true, filterParam: "status", selectOptions: TX_STATUS_OPTIONS },
    { key: "bank_nm", text: "은행", width: "70px", flex: 0.7, bodyAlign: "center" },
    { key: "accnt_no", text: "계좌번호", width: "100px", flex: 1, bodyAlign: "center" },
];

// ═══════════════════════════════════════
// ─── 메인 컴포넌트 ───
// ═══════════════════════════════════════
function WalletTransactionHistory() {
    const dispatch = useDispatch();
    const [activeTab, setActiveTab] = useState('merchant');
    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState({ msg: "" });

    // 각 탭의 건수
    const [merchantCount, setMerchantCount] = useState(0);
    const [agentCount, setAgentCount] = useState(0);

    useEffect(() => {
        dispatch(change_Current_Location("입출금내역"));
        dispatch(changeHeaderTitle({ mainTitle: "관리자", subTitle: "입출금내역" }));
        setTimeout(() => setLoading(false), 500);
    }, []);

    const totalCount = activeTab === 'merchant' ? merchantCount : agentCount;

    return (
        <div className="content" id="contents">
            {loading ? <LoadingModal /> : ""}
            <MessageModal message={message} setMessage={setMessage} />

            {/* 가맹점 지갑 */}
            <div style={{ display: activeTab === 'merchant' ? "block" : "none" }}>
                <MerchantTableContent onCountChange={setMerchantCount}
                    tabBar={<TabBar activeTab={activeTab} setActiveTab={setActiveTab} totalCount={totalCount} />} />
            </div>
            {/* 영업자 지갑 */}
            <div style={{ display: activeTab === 'agent' ? "block" : "none" }}>
                <AgentTableContent onCountChange={setAgentCount}
                    tabBar={<TabBar activeTab={activeTab} setActiveTab={setActiveTab} totalCount={totalCount} />} />
            </div>
        </div>
    );
}

// ─── 공용: 탭 + 건수 바 ───
function TabBar({ activeTab, setActiveTab, totalCount }) {
    return (
        <div className="tabulator_sorting_wrap" style={{ flexDirection: "row" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                {["merchant", "agent"].map((tab) => (
                    <button key={tab} onClick={() => setActiveTab(tab)} style={{
                        padding: "12px 10px 8px", fontSize: "14px",
                        fontWeight: activeTab === tab ? "600" : "400",
                        color: activeTab === tab ? "#222" : "#888",
                        background: "transparent", border: "none",
                        borderBottom: activeTab === tab ? "3px solid #3182F6" : "3px solid transparent",
                        transition: "all 0.2s ease-in-out", cursor: "pointer",
                    }}>
                        {tab === "merchant" ? "가맹점 지갑" : "영업자 지갑"}
                    </button>
                ))}
            </div>
            <div style={{ fontSize: "12px", color: "#6b7280" }}>
                총 <b style={{ color: "#1e3a5f" }}>{(totalCount ?? 0).toLocaleString()}</b>건
            </div>
        </div>
    );
}

// ═══════════════════════════════════════
// ─── 공용: 커스텀 테이블 ───
// ═══════════════════════════════════════
function HeaderCell({ col, i, colCount, filters, onFilterChange, onFilterKeyDown, onSelectChange, sortKey, sortDir, onSort }) {
    const style = {
        ...colFlex(col), display: "flex", alignItems: "center", justifyContent: "center", padding: "0",
        borderRight: i < colCount - 1 ? "1px solid rgba(255,255,255,0.15)" : "none",
    };
    if (col.filterable) {
        return (
            <div style={style}>
                <div style={{ position: "relative", width: "100%", display: "flex", alignItems: "center" }}>
                    <Search size={13} style={{ position: "absolute", left: "8px", opacity: 0.5, pointerEvents: "none" }} />
                    <input className="wallet-header-filter" type="text" value={filters[col.filterParam] || ""}
                        onChange={(e) => onFilterChange(col.filterParam, e.target.value)} onKeyDown={onFilterKeyDown}
                        placeholder={col.text} style={{ width: "100%", height: "38px", padding: "0 8px 0 26px", fontSize: "13px", border: "none", outline: "none", backgroundColor: "transparent", color: "#fff", boxSizing: "border-box" }} />
                </div>
            </div>
        );
    }
    if (col.selectable) {
        return (
            <div style={style}>
                <select
                    className="wallet-header-filter"
                    value={filters[col.filterParam] || ""}
                    onChange={(e) => onSelectChange(col.filterParam, e.target.value)}
                    style={{
                        width: "100%", height: "38px", padding: "0 4px",
                        fontSize: "12px", border: "none", outline: "none",
                        backgroundColor: "transparent", color: "#fff",
                        boxSizing: "border-box", cursor: "pointer",
                        appearance: "none", WebkitAppearance: "none",
                        backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'%3E%3Cpath d='M0 0l5 6 5-6z' fill='rgba(255,255,255,0.6)'/%3E%3C/svg%3E\")",
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "right 6px center",
                        paddingRight: "18px",
                    }}
                >
                    {Object.keys(col.selectOptions).map((label) => (
                        <option key={label} value={col.selectOptions[label]} style={{ color: "#333", backgroundColor: "#fff" }}>
                            {label}
                        </option>
                    ))}
                </select>
            </div>
        );
    }
    if (col.sortable) {
        const active = sortKey === col.key;
        return (
            <div style={{ ...style, cursor: "pointer", userSelect: "none" }} onClick={() => onSort(col.key)}
                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.1)"}
                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "transparent"}>
                <span style={{ padding: "0 4px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{col.text}</span>
                {active ? (sortDir === "asc" ? <ChevronUp size={14} style={{ flexShrink: 0 }} /> : <ChevronDown size={14} style={{ flexShrink: 0 }} />)
                    : <ChevronsUpDown size={14} style={{ flexShrink: 0, opacity: 0.4 }} />}
            </div>
        );
    }
    return (<div style={style}><span style={{ padding: "0 8px", lineHeight: "38px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{col.text}</span></div>);
}

function CustomTable({ columns, data, spinner, headerRef, bodyRef, observerRef, renderCell, onRowClick, filters, onFilterChange, onFilterKeyDown, onSelectChange, sortKey, sortDir, onSort }) {
    return (
        <div style={{ border: "1px solid #e2e5e9", borderRadius: "6px", overflow: "hidden", flex: 1, minHeight: 0, display: "flex", flexDirection: "column" }}>
            <div style={{ overflowX: "hidden", flexShrink: 0 }} ref={headerRef}>
                <div style={{ display: "flex", backgroundColor: "#1e3a5f", color: "#fff", fontSize: "13px", fontWeight: "500" }}>
                    {columns.map((col, i) => (
                        <HeaderCell key={i} col={col} i={i} colCount={columns.length} filters={filters} onFilterChange={onFilterChange} onFilterKeyDown={onFilterKeyDown} onSelectChange={onSelectChange} sortKey={sortKey} sortDir={sortDir} onSort={onSort} />
                    ))}
                </div>
            </div>
            <div style={{ overflow: "auto", flex: 1, minHeight: 0 }} ref={bodyRef}>
                {spinner ? (
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "200px" }}><SyncLoader color="#1e3a5f" size={8} /></div>
                ) : data.length === 0 ? (
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "200px", color: "#9ca3af" }}>
                        <FileX size={36} strokeWidth={1} /><p style={{ marginTop: "8px", fontSize: "13px" }}>데이터가 없습니다</p>
                    </div>
                ) : (
                    <>{data.map((row, rowIdx) => (
                        <div key={rowIdx} onClick={() => onRowClick?.(row)} style={{
                            display: "flex", minHeight: "40px", alignItems: "center", borderBottom: "1px solid #f0f0f0",
                            backgroundColor: rowIdx % 2 === 0 ? "#fff" : "#fafbfc", fontSize: "13px",
                            cursor: onRowClick ? "pointer" : "default", transition: "background-color 0.1s",
                        }}
                            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#f0f4ff"}
                            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = rowIdx % 2 === 0 ? "#fff" : "#fafbfc"}>
                            {columns.map((col, colIdx) => (
                                <div key={colIdx} style={{ ...colFlex(col), textAlign: col.bodyAlign || "center", padding: "8px 10px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                    {renderCell(col, row)}
                                </div>
                            ))}
                        </div>
                    ))}<div ref={observerRef} style={{ height: "1px" }} /></>
                )}
            </div>
        </div>
    );
}

// ═══════════════════════════════════════
// ─── 가맹점 지갑 ───
// ═══════════════════════════════════════
function MerchantTableContent({ onCountChange, tabBar }) {
    const navigate = useNavigate();
    const [page, setPage] = useState(1);
    const [maxFirstPage] = useState(30);
    const [listData, setListData] = useState({});
    const [listTrxData, setListTrxData] = useState([]);
    const [reload, setReload] = useState(false);
    const [spinner, setSpinner] = useState(false);

    const [preDate, setPreDate] = useState(dayjs().subtract(7, 'day').format('YYYY-MM-DD'));
    const [nextDate, setNextDate] = useState(dayjs().format('YYYY-MM-DD'));
    const [filters, setFilters] = useState({});
    const debounceRef = useRef(null);
    const [sortKey, setSortKey] = useState(null);
    const [sortDir, setSortDir] = useState(null);
    const [balanceData, setBalanceData] = useState(null);
    const [detailModal, setDetailModal] = useState(false);
    const [detailData, setDetailData] = useState(null);

    const startInputRef = useRef(null);
    const endInputRef = useRef(null);
    const startPickerRef = useRef(null);
    const endPickerRef = useRef(null);
    const observerRef = useRef(null);
    const bodyRef = useRef(null);
    const headerRef = useRef(null);

    useEffect(() => {
        startPickerRef.current = new Litepicker({
            ...datePickerCommonOpts,
            element: startInputRef.current,
            setup: (picker) => {
                picker.on('render', paintWeekendColors);
                picker.on('selected', (date) => { setPage(1); setPreDate(date.format('YYYY-MM-DD')); });
            }
        });
        endPickerRef.current = new Litepicker({
            ...datePickerCommonOpts,
            element: endInputRef.current,
            setup: (picker) => {
                picker.on('render', paintWeekendColors);
                picker.on('selected', (date) => { setPage(1); setNextDate(date.format('YYYY-MM-DD')); });
            }
        });
        return () => {
            if (startPickerRef.current) startPickerRef.current.destroy();
            if (endPickerRef.current) endPickerRef.current.destroy();
        };
    }, []);

    const setDateRange = (start, end) => {
        const s = start.replace(/\//g, '-');
        const e = end.replace(/\//g, '-');
        setPreDate(s); setNextDate(e);
        if (startPickerRef.current) startPickerRef.current.setDate(s);
        if (endPickerRef.current) endPickerRef.current.setDate(e);
        setPage(1); setReload(x => !x);
    };

    const handleFilterChange = (fp, v) => { setFilters(p => ({ ...p, [fp]: v })); if (debounceRef.current) clearTimeout(debounceRef.current); debounceRef.current = setTimeout(() => { setPage(1); setReload(e => !e); }, 400); };
    const handleFilterKeyDown = (e) => { if (e.key === 'Enter') { e.preventDefault(); if (debounceRef.current) clearTimeout(debounceRef.current); setPage(1); setReload(e => !e); } };
    const handleSort = (key) => { if (sortKey === key) { if (sortDir === "asc") setSortDir("desc"); else { setSortKey(null); setSortDir(null); } } else { setSortKey(key); setSortDir("asc"); } setPage(1); setReload(e => !e); };
    const handleSelectChange = (filterParam, value) => {
        setFilters(p => ({ ...p, [filterParam]: value }));
        setPage(1);
        setReload(e => !e);
    };

    const fetchBalance = async (mid) => {
        if (!mid) { setBalanceData(null); return; }
        try { const r = await axios.get(process.env.REACT_APP_API + "/api/merchant/wallet/accounts", { withCredentials: true, params: { mid } }); if (r?.data?.code < 2000) setBalanceData(r.data.data ?? null); } catch (e) { console.error(e); }
    };
    useEffect(() => { const mid = filters.mid?.trim(); if (mid && mid.length >= 2) fetchBalance(mid); else setBalanceData(null); }, [filters.mid]);

    useEffect(() => { ListData(); }, [page, maxFirstPage, reload]);
    const ListData = async () => {
        if (page === 1) setSpinner(true);
        try {
            const params = { page, limit: maxFirstPage };
            if (preDate) params.startDate = preDate;
            if (nextDate) params.endDate = nextDate;
            if (filters.txType) params.txType = filters.txType;
            if (filters.status) params.status = filters.status;
            if (filters.mid) params.mid = filters.mid.trim();
            if (sortKey && sortDir) { params.sortBy = sortKey; params.sortDir = sortDir; }
            const r = await axios.get(process.env.REACT_APP_API + "/api/merchant/wallet/transactions", { withCredentials: true, params });
            let tmp = r?.data;
            if (tmp?.code < 2000) {
                setListData(tmp?.data ?? {});
                const list = tmp?.data?.transactions ?? [];
                if (page === 1) setListTrxData(list); else setListTrxData(p => [...p, ...list]);
                onCountChange?.(tmp?.data?.pagination?.total ?? tmp?.data?.totCnt ?? 0);
            } else if (tmp?.code === 9999) { navigate('/'); }
        } catch (e) { console.error(e); }
        setSpinner(false);
    };

    useEffect(() => {
        if (listTrxData.length === 0) return;
        const total = listData?.pagination?.total ?? listData?.totCnt ?? 0;
        const observer = new IntersectionObserver(([entry]) => { if (entry.isIntersecting && total >= page * maxFirstPage) setPage(p => p + 1); });
        if (observerRef.current) observer.observe(observerRef.current);
        return () => { if (observerRef.current) observer.unobserve(observerRef.current); };
    }, [listTrxData, listData]);
    useEffect(() => { const el = bodyRef.current; if (!el) return; const h = () => { if (headerRef.current) headerRef.current.scrollLeft = el.scrollLeft; }; el.addEventListener("scroll", h); return () => el.removeEventListener("scroll", h); }, []);
    useEffect(() => { if (page === 1 && bodyRef.current) bodyRef.current.scrollTop = 0; }, [page]);

    const renderCell = (col, data) => {
        switch (col.key) {
            case "created_at": return data.created_at ? dayjs.utc(data.created_at).tz('Asia/Seoul').format('YYYY-MM-DD HH:mm') : "-";
            case "mid": return data.mid ?? "-";
            case "merchant_name": return data.merchant_name ?? "-";
            case "boss_name": return data.boss_name ?? "-";
            case "tx_type": return (data.tx_type_kr && data.tx_type_kr !== data.tx_type) ? data.tx_type_kr : (TX_TYPE_KR[data.tx_type] ?? data.tx_type ?? "-");
            case "tx_direction": { const c = TX_DIRECTION_COLOR[data.tx_direction] || '#1f2937'; return <span style={{ color: c, fontWeight: "600" }}>{TX_DIRECTION_KR[data.tx_direction] ?? "-"}</span>; }
            case "amount": { const c = TX_DIRECTION_COLOR[data.tx_direction] || '#1f2937'; const a = Math.abs(Number(data.amount) || 0); const p = data.tx_direction === 'OUT' ? '-' : data.tx_direction === 'IN' ? '+' : ''; return <span style={{ color: c, fontWeight: "600" }}>{p}{safeNum(a)}</span>; }
            case "balance_before": return safeNum(data.balance_before);
            case "balance_after": return safeNum(data.balance_after);
            case "status": { const c = data.status === 'SUCCESS' ? '#059669' : data.status === 'FAILED' ? '#dc2626' : data.status === 'CANCELED' ? '#6b7280' : '#d97706'; return <span style={{ color: c, fontWeight: "600", fontSize: "11px" }}>{data.status_kr ?? data.status ?? "-"}</span>; }
            case "bank_nm": return data.bank_nm ?? "-";
            case "accnt_no": return data.accnt_no ?? "-";
            default: return "-";
        }
    };

    return (
        <>
            {/* 필터 */}
            <div className="form_filter intro-y">
                <form id="tabulator-html-filter-form">
                    <SearchDateSplit startInputRef={startInputRef} endInputRef={endInputRef} setDateRange={setDateRange} preDate={preDate} nextDate={nextDate} />
                </form>
            </div>

            <div className="intro-y box intro-padding">
                {tabBar}

                {/* 잔액 요약 */}
                {balanceData && (
                    <div style={{ display: "flex", gap: "16px", padding: "8px 0", fontSize: "12px", color: "#6b7280" }}>
                        <SummaryItem label="가맹점" value={balanceData.merchant_name ?? balanceData.co_nm ?? filters.mid ?? "-"} />
                        <span style={{ color: "#d1d5db" }}>|</span>
                        <SummaryItem label="총잔액" value={`${safeNum(balanceData.total_balance)}원`} />
                        <SummaryItem label="가용잔액" value={`${safeNum(balanceData.available_balance)}원`} color="#059669" />
                        <SummaryItem label="잠금잔액" value={`${safeNum(balanceData.frozen_balance)}원`} color="#dc2626" />
                    </div>
                )}

                {/* 테이블 */}
                <CustomTable columns={MERCHANT_COLUMNS} data={listTrxData} spinner={spinner}
                    headerRef={headerRef} bodyRef={bodyRef} observerRef={observerRef}
                    renderCell={renderCell} onRowClick={(row) => { setDetailData(row); setDetailModal(true); }}
                    filters={filters} onFilterChange={handleFilterChange} onFilterKeyDown={handleFilterKeyDown}
                    onSelectChange={handleSelectChange} sortKey={sortKey} sortDir={sortDir} onSort={handleSort} />
            </div>

            {/* 상세 모달 */}
            {detailModal && detailData && (
                <ModalOverlay onClose={() => setDetailModal(false)}>
                    <div style={{ width: "480px", maxHeight: "80vh", overflow: "auto" }}>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" }}>
                            <h3 style={{ fontSize: "16px", fontWeight: "700", margin: 0 }}>거래 상세</h3>
                            <button onClick={() => setDetailModal(false)} style={closeBtnStyle}><X size={18} /></button>
                        </div>
                        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "8px", fontSize: "13px" }}>
                            <InfoRow label="일시" value={detailData.created_at ? dayjs.utc(detailData.created_at).tz('Asia/Seoul').format('YYYY-MM-DD HH:mm:ss') : "-"} />
                            <InfoRow label="MID" value={detailData.mid ?? "-"} />
                            <InfoRow label="가맹점명" value={detailData.merchant_name ?? "-"} />
                            <InfoRow label="대표자명" value={detailData.boss_name ?? "-"} />
                            <InfoRow label="거래유형" value={TX_TYPE_KR[detailData.tx_type] ?? detailData.tx_type_kr ?? detailData.tx_type ?? "-"} />
                            <InfoRow label="방향" value={<span style={{ color: TX_DIRECTION_COLOR[detailData.tx_direction] || '#1f2937', fontWeight: "600" }}>{TX_DIRECTION_KR[detailData.tx_direction] ?? "-"}</span>} />
                            <InfoRow label="금액" value={<span style={{ color: TX_DIRECTION_COLOR[detailData.tx_direction] || '#1f2937', fontWeight: "700" }}>{safeNum(Math.abs(Number(detailData.amount) || 0))}원</span>} />
                            <InfoRow label="거래 전 잔액" value={`${safeNum(detailData.balance_before)}원`} />
                            <InfoRow label="거래 후 잔액" value={`${safeNum(detailData.balance_after)}원`} bold />
                            <InfoRow label="상태" value={<span style={{ color: detailData.status === 'SUCCESS' ? '#059669' : detailData.status === 'FAILED' ? '#dc2626' : '#d97706', fontWeight: "600" }}>{detailData.status_kr ?? detailData.status ?? "-"}</span>} />
                            <InfoRow label="은행" value={detailData.bank_nm ?? "-"} />
                            <InfoRow label="계좌번호" value={detailData.accnt_no ?? "-"} />
                            <InfoRow label="예금주" value={detailData.accnt_nm ?? "-"} />
                            {detailData.ref_id && <InfoRow label="참조ID" value={detailData.ref_id} />}
                        </div>
                    </div>
                </ModalOverlay>
            )}
        </>
    );
}

// ═══════════════════════════════════════
// ─── 영업자 지갑 (서브탭 없음, withdrawals 기본) ───
// ═══════════════════════════════════════
function AgentTableContent({ onCountChange, tabBar }) {
    const navigate = useNavigate();
    const [page, setPage] = useState(1);
    const [maxFirstPage] = useState(30);
    const [listData, setListData] = useState({});
    const [listTrxData, setListTrxData] = useState([]);
    const [reload, setReload] = useState(false);
    const [spinner, setSpinner] = useState(false);

    const [preDate, setPreDate] = useState(dayjs().subtract(7, 'day').format('YYYY-MM-DD'));
    const [nextDate, setNextDate] = useState(dayjs().format('YYYY-MM-DD'));
    const [filters, setFilters] = useState({});
    const debounceRef = useRef(null);
    const [sortKey, setSortKey] = useState(null);
    const [sortDir, setSortDir] = useState(null);
    const [balanceData, setBalanceData] = useState(null);
    const [totalsData, setTotalsData] = useState(null);
    const [detailModal, setDetailModal] = useState(false);
    const [detailData, setDetailData] = useState(null);

    const startInputRef = useRef(null);
    const endInputRef = useRef(null);
    const startPickerRef = useRef(null);
    const endPickerRef = useRef(null);
    const observerRef = useRef(null);
    const bodyRef = useRef(null);
    const headerRef = useRef(null);

    useEffect(() => {
        startPickerRef.current = new Litepicker({
            ...datePickerCommonOpts,
            element: startInputRef.current,
            setup: (picker) => {
                picker.on('render', paintWeekendColors);
                picker.on('selected', (date) => { setPage(1); setPreDate(date.format('YYYY-MM-DD')); });
            }
        });
        endPickerRef.current = new Litepicker({
            ...datePickerCommonOpts,
            element: endInputRef.current,
            setup: (picker) => {
                picker.on('render', paintWeekendColors);
                picker.on('selected', (date) => { setPage(1); setNextDate(date.format('YYYY-MM-DD')); });
            }
        });
        return () => {
            if (startPickerRef.current) startPickerRef.current.destroy();
            if (endPickerRef.current) endPickerRef.current.destroy();
        };
    }, []);

    const setDateRange = (start, end) => {
        const s = start.replace(/\//g, '-');
        const e = end.replace(/\//g, '-');
        setPreDate(s); setNextDate(e);
        if (startPickerRef.current) startPickerRef.current.setDate(s);
        if (endPickerRef.current) endPickerRef.current.setDate(e);
        setPage(1); setReload(x => !x);
    };

    const handleFilterChange = (fp, v) => { setFilters(p => ({ ...p, [fp]: v })); if (debounceRef.current) clearTimeout(debounceRef.current); debounceRef.current = setTimeout(() => { setPage(1); setReload(e => !e); }, 400); };
    const handleFilterKeyDown = (e) => { if (e.key === 'Enter') { e.preventDefault(); if (debounceRef.current) clearTimeout(debounceRef.current); setPage(1); setReload(e => !e); } };
    const handleSort = (key) => { if (sortKey === key) { if (sortDir === "asc") setSortDir("desc"); else { setSortKey(null); setSortDir(null); } } else { setSortKey(key); setSortDir("asc"); } setPage(1); setReload(e => !e); };
    const handleSelectChange = (filterParam, value) => {
        setFilters(p => ({ ...p, [filterParam]: value }));
        setPage(1);
        setReload(e => !e);
    };

    const fetchBalance = async (id) => {
        if (!id) { setBalanceData(null); setTotalsData(null); return; }
        try {
            const [bR, tR] = await Promise.all([
                axios.get(process.env.REACT_APP_API + "/api/agent-wallet/balance", { withCredentials: true, params: { agentId: id } }),
                axios.get(process.env.REACT_APP_API + "/api/agent-wallet/totals", { withCredentials: true, params: { agentId: id } }),
            ]);
            if (bR?.data?.code < 2000) setBalanceData(bR.data.data ?? null);
            if (tR?.data?.code < 2000) setTotalsData(tR.data.data ?? null);
        } catch (e) { console.error(e); }
    };
    // TODO: 잔액/합계 조회 임시 비활성화
    // useEffect(() => { const id = filters.agentId?.trim(); if (id && id.length >= 2) fetchBalance(id); else { setBalanceData(null); setTotalsData(null); } }, [filters.agentId]);

    useEffect(() => { ListData(); }, [page, maxFirstPage, reload]);
    const ListData = async () => {
        if (page === 1) setSpinner(true);
        try {
            const params = { page, limit: maxFirstPage };
            if (filters.agentId) params.agentId = filters.agentId.trim();
            if (preDate) params.startDate = preDate;
            if (nextDate) params.endDate = nextDate;
            if (filters.txType) params.txType = filters.txType;
            if (filters.status) params.status = filters.status;
            if (sortKey && sortDir) { params.sortBy = sortKey; params.sortDir = sortDir; }
            const r = await axios.get(process.env.REACT_APP_API + "/api/agent-wallet/transactions", { withCredentials: true, params });
            let tmp = r?.data;
            if (tmp?.code < 2000) {
                setListData(tmp?.data ?? {});
                const list = tmp?.data?.transactions ?? tmp?.data?.list ?? [];
                if (page === 1) setListTrxData(list); else setListTrxData(p => [...p, ...list]);
                onCountChange?.(tmp?.data?.totCnt ?? tmp?.data?.totalItems ?? 0);
            } else if (tmp?.code === 9999) { navigate('/'); }
        } catch (e) { console.error(e); }
        setSpinner(false);
    };

    useEffect(() => {
        if (listTrxData.length === 0) return;
        const total = listData?.totCnt ?? listData?.totalItems ?? 0;
        const observer = new IntersectionObserver(([entry]) => { if (entry.isIntersecting && total >= page * maxFirstPage) setPage(p => p + 1); });
        if (observerRef.current) observer.observe(observerRef.current);
        return () => { if (observerRef.current) observer.unobserve(observerRef.current); };
    }, [listTrxData, listData]);
    useEffect(() => { const el = bodyRef.current; if (!el) return; const h = () => { if (headerRef.current) headerRef.current.scrollLeft = el.scrollLeft; }; el.addEventListener("scroll", h); return () => el.removeEventListener("scroll", h); }, []);
    useEffect(() => { if (page === 1 && bodyRef.current) bodyRef.current.scrollTop = 0; }, [page]);

    const renderCell = (col, data) => {
        const statusText = data.status_kr ?? (data.status === 'P' || data.status === 'SUCCESS' ? '완료' : data.status === 'W' || data.status === 'PENDING' ? '대기' : data.status === 'F' || data.status === 'FAILED' ? '실패' : data.status ?? '-');
        const statusColor = (data.status === 'P' || data.status === 'SUCCESS') ? '#059669' : (data.status === 'F' || data.status === 'FAILED') ? '#dc2626' : '#d97706';
        const isWithdraw = data.tx_type === 'WITHDRAW';
        const dirColor = isWithdraw ? '#dc2626' : '#059669';
        switch (col.key) {
            case "created_at": return data.created_at ? dayjs.utc(data.created_at).tz('Asia/Seoul').format('YYYY-MM-DD HH:mm') : "-";
            case "agent_id": return data.agent_id ?? "-";
            case "agent_nm": return data.agent_nm ?? "-";
            case "tx_type": { const label = data.tx_type_kr ?? (AGENT_TX_TYPE_KR[data.tx_type] ?? data.tx_type ?? "-"); return <span style={{ color: dirColor, fontWeight: "600" }}>{label}</span>; }
            case "amount": return <span style={{ color: dirColor, fontWeight: "600" }}>{safeNum(data.amount)}</span>;
            case "fee": return data.withdrawal_fee != null ? safeNum(data.withdrawal_fee) : safeNum(data.fee);
            case "final_amount": return data.final_amount != null ? safeNum(data.final_amount) : safeNum(data.actual_amount ?? data.amount);
            case "balance_after": return safeNum(data.balance_after);
            case "status": return <span style={{ color: statusColor, fontWeight: "600", fontSize: "11px" }}>{statusText}</span>;
            case "bank_nm": return data.bank_nm ?? data.bank_name ?? "-";
            case "accnt_no": return data.accnt_no ?? data.account_number ?? "-";
            default: return "-";
        }
    };

    return (
        <>
            {/* 필터 */}
            <div className="form_filter intro-y">
                <form id="tabulator-html-filter-form-agent">
                    <SearchDateSplit startInputRef={startInputRef} endInputRef={endInputRef} setDateRange={setDateRange} preDate={preDate} nextDate={nextDate} />
                </form>
            </div>

            <div className="intro-y box intro-padding">
                {tabBar}

                {/* 잔액 요약 */}
                {balanceData && (
                    <div style={{ display: "flex", gap: "16px", padding: "8px 0", fontSize: "12px", color: "#6b7280" }}>
                        <SummaryItem label="에이전트" value={balanceData.agent_nm ?? filters.agentId ?? "-"} />
                        <span style={{ color: "#d1d5db" }}>|</span>
                        <SummaryItem label="총잔액" value={`${safeNum(balanceData.available_balance ?? balanceData.total_balance)}원`} />
                        <SummaryItem label="가용잔액" value={`${safeNum(balanceData.available_balance)}원`} color="#059669" />
                        <SummaryItem label="잠금잔액" value={`${safeNum(balanceData.frozen_balance ?? balanceData.locked_balance)}원`} color="#dc2626" />
                        {totalsData && (<><span style={{ color: "#d1d5db" }}>|</span>
                            <SummaryItem label="총입금" value={`${safeNum(totalsData.total_deposit)}원`} color="#059669" />
                            <SummaryItem label="총출금" value={`${safeNum(totalsData.total_withdraw)}원`} color="#dc2626" /></>)}
                    </div>
                )}

                {/* 테이블 */}
                <CustomTable columns={AGENT_COLUMNS} data={listTrxData} spinner={spinner}
                headerRef={headerRef} bodyRef={bodyRef} observerRef={observerRef}
                renderCell={renderCell} onRowClick={(row) => { setDetailData(row); setDetailModal(true); }}
                filters={filters} onFilterChange={handleFilterChange} onFilterKeyDown={handleFilterKeyDown}
                onSelectChange={handleSelectChange} sortKey={sortKey} sortDir={sortDir} onSort={handleSort} />
            </div>

            {/* 상세 모달 */}
            {detailModal && detailData && (
                <ModalOverlay onClose={() => setDetailModal(false)}>
                    <div style={{ width: "480px", maxHeight: "80vh", overflow: "auto" }}>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" }}>
                            <h3 style={{ fontSize: "16px", fontWeight: "700", margin: 0 }}>거래 상세</h3>
                            <button onClick={() => setDetailModal(false)} style={closeBtnStyle}><X size={18} /></button>
                        </div>
                        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "8px", fontSize: "13px" }}>
                            <InfoRow label="일시" value={detailData.created_at ? dayjs.utc(detailData.created_at).tz('Asia/Seoul').format('YYYY-MM-DD HH:mm:ss') : "-"} />
                            <InfoRow label="에이전트ID" value={detailData.agent_id ?? "-"} />
                            <InfoRow label="에이전트명" value={detailData.agent_nm ?? "-"} />
                            <InfoRow label="거래유형" value={<span style={{ color: detailData.tx_type === 'WITHDRAW' ? '#dc2626' : '#059669', fontWeight: "600" }}>{detailData.tx_type_kr ?? AGENT_TX_TYPE_KR[detailData.tx_type] ?? detailData.tx_type ?? "-"}</span>} />
                            <InfoRow label="금액" value={<span style={{ color: detailData.tx_type === 'WITHDRAW' ? '#dc2626' : '#059669', fontWeight: "700" }}>{safeNum(detailData.amount)}원</span>} />
                            {(detailData.withdrawal_fee != null || detailData.fee != null) && <InfoRow label="수수료" value={`${safeNum(detailData.withdrawal_fee ?? detailData.fee)}원`} />}
                            {(detailData.final_amount != null || detailData.actual_amount != null) && <InfoRow label="최종금액" value={`${safeNum(detailData.final_amount ?? detailData.actual_amount)}원`} bold />}
                            {detailData.bank_nm && <InfoRow label="은행" value={detailData.bank_nm ?? detailData.bank_name ?? "-"} />}
                            {detailData.accnt_no && <InfoRow label="계좌번호" value={detailData.accnt_no ?? detailData.account_number ?? "-"} />}
                            {detailData.accnt_nm && <InfoRow label="예금주" value={detailData.accnt_nm ?? detailData.account_holder ?? "-"} />}
                            <InfoRow label="잔액(후)" value={`${safeNum(detailData.balance_after)}원`} bold />
                            <InfoRow label="상태" value={<span style={{ color: (detailData.status === 'P' || detailData.status === 'SUCCESS') ? '#059669' : (detailData.status === 'F' || detailData.status === 'FAILED') ? '#dc2626' : '#d97706', fontWeight: "600" }}>{detailData.status_kr ?? detailData.status ?? "-"}</span>} />
                            {detailData.memo && <InfoRow label="메모" value={detailData.memo} span2 />}
                        </div>
                    </div>
                </ModalOverlay>
            )}
        </>
    );
}

// ─── 공통 컴포넌트 ───
function ModalOverlay({ children, onClose }) {
    return (
        <div style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "rgba(0,0,0,0.5)", zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center" }}
            onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
            <div style={{ backgroundColor: "#fff", borderRadius: "8px", padding: "20px", boxShadow: "0 4px 20px rgba(0,0,0,0.15)" }}>{children}</div>
        </div>
    );
}
function SummaryItem({ label, value, color }) {
    return (<span><span style={{ color: "#6b7280" }}>{label} </span><strong style={{ color: color || "#1f2937" }}>{value}</strong></span>);
}
function InfoRow({ label, value, bold, span2 }) {
    return (<div style={{ gridColumn: span2 ? "1 / -1" : undefined }}><span style={{ color: "#6b7280", fontSize: "12px" }}>{label}</span><div style={{ fontWeight: bold ? "700" : "500", fontSize: "13px" }}>{value}</div></div>);
}
const closeBtnStyle = { background: "none", border: "none", cursor: "pointer", padding: "4px", display: "flex" };

export default WalletTransactionHistory;
